/**
 * Telegram Mini App utilities
 * TMA init, theme sync, haptic feedback
 */

const tg = typeof window !== 'undefined' ? (window as unknown as { Telegram?: { WebApp: TelegramWebApp } }).Telegram?.WebApp : null

interface TelegramWebApp {
  version?: string
  ready: () => void
  expand: () => void
  close: () => void
  setHeaderColor: (color: string) => void
  setBackgroundColor: (color: string) => void
  themeParams: { bg_color?: string; text_color?: string; hint_color?: string; button_color?: string }
  colorScheme: 'light' | 'dark'
  HapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy') => void
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void
    selectionChanged: () => void
  }
}

export function initTelegram() {
  if (!tg) return
  tg.ready()
  tg.expand()
  tg.setHeaderColor('#0a0a0a')
  tg.setBackgroundColor('#0a0a0a')
}

export function useTelegramTheme() {
  if (!tg) return null
  return {
    bgColor: tg.themeParams.bg_color ?? '#0a0a0a',
    textColor: tg.themeParams.text_color ?? '#fafafa',
    scheme: tg.colorScheme,
  }
}

/** HapticFeedback unsupported in Telegram 6.0 — skip to avoid console warning */
function isHapticSupported(): boolean {
  const v = tg?.version ?? ''
  return !v.startsWith('6.0')
}

export function hapticLight() {
  if (!isHapticSupported()) return
  try {
    tg?.HapticFeedback?.impactOccurred?.('light')
  } catch {
    // not supported
  }
}

export function hapticMedium() {
  if (!isHapticSupported()) return
  try {
    tg?.HapticFeedback?.impactOccurred?.('medium')
  } catch {
    // not supported
  }
}

export function hapticSuccess() {
  if (!isHapticSupported()) return
  try {
    tg?.HapticFeedback?.notificationOccurred?.('success')
  } catch {
    // not supported
  }
}

export function hapticError() {
  if (!isHapticSupported()) return
  try {
    tg?.HapticFeedback?.notificationOccurred?.('error')
  } catch {
    // not supported
  }
}

export function hapticSelection() {
  if (!isHapticSupported()) return
  try {
    tg?.HapticFeedback?.selectionChanged?.()
  } catch {
    // not supported
  }
}

export const isTelegram = !!tg
